var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
export default isReactNative;


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/isReactNative.js
// module id = 8H8L
// module chunks = 1